// Filled variants, for the few places that showed a solid icon next to an
// outline one (a starred row, a completed step).
import * as P from '@phosphor-icons/react';
import { withWeight } from './index';

export const StarIcon = withWeight(P.Star, 'fill');
export const CheckCircleIcon = withWeight(P.CheckCircle, 'fill');
